<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="piv"> First Mariner Books Edition 2002</a></p><a id="piv">
<p class="timebreak"> <br/></p>
<p class="center">Copyright © 1994 by Howard Frank Mosher</p>
<p class="timebreak"> <br/></p>
<p class="center">All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
</a><p class="center"><a id="piv"></a><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center">Cataloging-in-Publication Data is available.</p>
<p class="timebreak"> <br/></p>
<p class="center"><span style="font-size: smaller">ISBN</span> 0-618-24009-8</p>
<p class="timebreak"> <br/></p>
<p class="center">e<span style="font-size: smaller">ISBN</span> 978-0-547-52654-6<br/>
v1.0714</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?17882e10